export default {
  List: {
    select: 'id,name,created,status,creator,executedPercent',
    searchSelect: ['process/name', 'name', 'process/processGroup/name'],
    expand: {
      process: {
        select: 'name,isShowPercentEnabled',
        expand: { processGroup: { select: 'name' } },
      },
    },
    orderBy: 'created desc',
  },

  BulkUpload: {
    select: 'id,status,created,number,fileName,processingDate,processedDate',
    searchSelect: ['process/name', 'number', 'fileName', 'userCreator/fullName'],
    expand: {
      process: {
        select: 'name',
        expand: { processGroup: { select: 'name' } },
      },
      userCreator: { select: 'fullName' },
    },
    orderBy: 'created desc',
  },

  BulkTaskDetail: {
    expand: {
      process: { select: 'name' },
      userCreator: { select: 'fullName' },
    },
  },

  BulkTaskPaged: {
    select:
      'id,status,created,lineNumber,bulkRequestNumber,isSuccessfullyOperation,processInstanceId,processInstanceName,observations',
    searchSelect: ['processInstanceName', 'observations'],
  },
};
